import axios from "axios";
import { API_ROOT, COOKIE_NAME } from "../constants";
import { setCookie, errorResponse, getAffiliate } from "../helpers";
import moment from "moment";
import { trackEvent, EC_ACCOUNT, E_UPDATE_PROFILE } from "../helpers/tracking";
// Authentication.
export const LOGIN_REQUEST_START = "LOGIN_REQUEST_START";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAIL = "LOGIN_REQUEST_FAIL";

export const REQUEST_PASSWORD_RESET_START = "REQUEST_PASSWORD_RESET_START";
export const REQUEST_PASSWORD_RESET_SUCCESS = "REQUEST_PASSWORD_RESET_SUCCESS";
export const REQUEST_PASSWORD_RESET_FAIL = "REQUEST_PASSWORD_RESET_FAIL";

export const PASSWORD_RESET_START = "PASSWORD_RESET_START";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_FAIL = "PASSWORD_RESET_FAIL";

export const SIGNUP_REQUEST_START = "SIGNUP_REQUEST_START";
export const SIGNUP_REQUEST_SUCCESS = "SIGNUP_REQUEST_SUCCESS";
export const SIGNUP_REQUEST_FAIL = "SIGNUP_REQUEST_FAIL";

export const CURRENT_USER_REQUEST_START = "CURRENT_USER_REQUEST_START";
export const CURRENT_USER_REQUEST_SUCCESS = "CURRENT_USER_REQUEST_SUCCESS";
export const CURRENT_USER_REQUEST_FAIL = "CURRENT_USER_REQUEST_FAIL";

export const CHANGE_ADDRESSES_REQUEST_START = "CHANGE_ADDRESSES_REQUEST_START";
export const CHANGE_ADDRESS_REQUEST_SUCCESS = "CHANGE_ADDRESS_REQUEST_SUCCESS";
export const CHANGE_ADDRESSES_REQUEST_FAIL = "CHANGE_ADDRESSES_REQUEST_FAIL";

export const UPDATE_PROFILE_START = "UPDATE_PROFILE_START";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";

export const LOGOUT = "LOGOUT";
// Misc
export const SET_SESSION_DATA = "SET_SESSION_DATA";

// For authenticating a user.
export function login({ email, password }) {
	return function (dispatch) {
		dispatch({ type: LOGIN_REQUEST_START });

		axios.post(`${API_ROOT}/auth/local`, {
			identifier: email,
			password,
		}).then(({ data }) => {
			// Success!
			dispatch({
				type: LOGIN_REQUEST_SUCCESS,
				user: data.user,
				token: data.jwt
			});
			// Also set a cookie.
			setCookie({
				key: COOKIE_NAME,
				value: data.jwt,
				path: "/",
				expires: moment().add(1, "month")
			});
			window._hsq.push(["identify", {
				email: data.user.email
			}]);
		}).catch(error => {
			dispatch({
				type: LOGIN_REQUEST_FAIL,
				error: errorResponse(error)
			});
		});

	}
}

// Requesting a password reset email.
export function requestPasswordReset({ email }, callback) {
	return function (dispatch) {
		dispatch({ type: REQUEST_PASSWORD_RESET_START });

		axios.post(`${API_ROOT}/auth/forgot-password`, {
			email,
		}).then(({ data }) => {
			// Success!
			dispatch({
				type: REQUEST_PASSWORD_RESET_SUCCESS
			});
			if (callback) callback();
		}).catch(error => {
			dispatch({
				type: REQUEST_PASSWORD_RESET_FAIL,
				error: errorResponse(error)
			});
		});

	}
}

// Resetting the password using the passed code.
export function passwordReset({ code, password }, callback) {
	return function (dispatch) {
		dispatch({ type: PASSWORD_RESET_START });

		axios.post(`${API_ROOT}/auth/reset-password`, {
			code,
			password,
			passwordConfirmation: password,
		}).then(res => res.data).then(data => {
			// Check the user is actually validated.
			if (!data.user.confirmed) {
				let error = "Your password was reset, but your email address has never been confirmed. Go find your welcome email and click the link."
				dispatch({
					type: PASSWORD_RESET_FAIL,
					error
				});
				if (callback) callback(error);
				return;
			}
			// Successfully resetting the password can log them in.
			dispatch({
				type: PASSWORD_RESET_SUCCESS,
				user: data.user,
				token: data.jwt
			});
			// Also set a cookie.
			setCookie({
				key: COOKIE_NAME,
				value: data.jwt,
				path: "/",
				expires: moment().add(1, "month")
			});
			window._hsq.push(["identify", {
				email: data.user.email
			}]);
			if (callback) callback(null);
		}).catch(error => {
			dispatch({
				type: PASSWORD_RESET_FAIL,
				error: errorResponse(error)
			});
		});

	}
}

export function signup({ email, password, firstName, lastName }) {
	return function (dispatch) {
		dispatch({ type: SIGNUP_REQUEST_START });

		// Check for affiliate codes.
		const aa = getAffiliate();

		axios.post(`${API_ROOT}/auth/local/register`, {
			email,
			password,
			firstName,
			lastName
		}, aa ? {
			params: { aa }
		} : undefined).then(({ data }) => {
			// Success!
			dispatch({
				type: SIGNUP_REQUEST_SUCCESS,
				user: data.user,
				token: data.jwt
			});
			// Also set a cookie.
			setCookie({
				key: COOKIE_NAME,
				value: data.jwt,
				path: "/",
				expires: moment().add(1, "month")
			});
			window._hsq.push(["identify", {
				email: data.user.email
			}]);
		}).catch(error => {
			dispatch({
				type: SIGNUP_REQUEST_FAIL,
				error: errorResponse(error)
			});
		});

	}
}

export function socialLogin({ provider, access_token }, callback) {
	return function (dispatch) {

		// Check for affiliate codes.
		const aa = getAffiliate();

		dispatch({ type: LOGIN_REQUEST_START });

		axios.get(`${API_ROOT}/auth/${provider}/callback?access_token=${access_token}`, aa ? {
			params: { aa }
		} : undefined)
			.then(({ data }) => {
				// Success!
				dispatch({
					type: LOGIN_REQUEST_SUCCESS,
					user: data.user,
					token: data.jwt
				});
				// Also set a cookie.
				setCookie({
					key: COOKIE_NAME,
					value: data.jwt,
					path: "/",
					expires: moment().add(1, "month")
				});
				window._hsq.push(["identify", {
					email: data.user.email
				}]);
				if (callback) callback(null, data);
			}).catch(rawError => {
				let error = errorResponse(rawError);
				dispatch({
					type: LOGIN_REQUEST_FAIL,
					error
				});
				if (callback) callback(error, null);
			});

	}
}

export function requestCurrentUser() {
	return function (dispatch, getState) {
		// Trigger the start.
		dispatch({
			type: CURRENT_USER_REQUEST_START
		});
		// Get the current token.
		const { session: { token } } = getState();
		// If there isn't one, we can exit early.
		if (!token) return dispatch({
			type: CURRENT_USER_REQUEST_FAIL
		});

		axios.get(`${API_ROOT}/users/me`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		}).then(res => res.data).then(user => {
			dispatch({
				type: CURRENT_USER_REQUEST_SUCCESS,
				user
			});
			window._hsq.push(["identify", {
				email: user.email
			}]);
		}).catch(error => {
			setCookie({
				key: COOKIE_NAME,
				path: "/",
				value: ""
			});
			dispatch({
				type: CURRENT_USER_REQUEST_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function logout() {
	setCookie({
		key: COOKIE_NAME,
		path: "/",
		value: ""
	});
	return {
		type: LOGOUT
	}
}

// For setting general session data.
export function setSessionData(data) {
	return {
		type: SET_SESSION_DATA,
		data
	}
};

export function changeAddresses(addresses) {
	return function (dispatch, getState) {

		// Get the current token.
		const { session: { token } } = getState();
		// If there isn't one, we can exit early.
		if (!token) return;

		dispatch({
			type: CHANGE_ADDRESSES_REQUEST_START,
			addresses
		});

		axios.post(`${API_ROOT}/misc/address`, addresses, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		}).then(res => res.data).then(newAddresses => {
			dispatch({
				type: CHANGE_ADDRESS_REQUEST_SUCCESS,
				addresses: newAddresses
			});
		}).catch(error => {
			dispatch({
				type: CHANGE_ADDRESSES_REQUEST_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

export function requestNotificationPermission(force = false) {
	return function (dispatch, getState) {

		const { session: { notificationState } } = getState();

		if (
			!force &&
			(
				notificationState === "denied" ||
				notificationState === "granted" ||
				!window.Notification
			)
		) return;

		Notification.requestPermission(notificationState => {
			dispatch(setSessionData({ notificationState }));
		});
	}
}

export function updateProfile(changes) {
	return function (dispatch, getState) {

		// Get the current token.
		const { session: { token } } = getState();
		// If there isn't one, we can exit early.
		if (!token) return;

		dispatch({
			type: UPDATE_PROFILE_START,
		});

		axios.put(`${API_ROOT}/profile`, changes, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		}).then(res => res.data).then(user => {
			dispatch({
				type: UPDATE_PROFILE_SUCCESS,
				user
			});

			// Track events.
			Object.keys(changes).forEach(field => trackEvent(EC_ACCOUNT, E_UPDATE_PROFILE, field));

		}).catch(err => {
			dispatch({
				type: UPDATE_PROFILE_FAIL,
				error: errorResponse(err)
			});
		});

	}

}